var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      staticStyle: {
        "max-width": "100vw",
        "overflow-x": "hidden",
        "overflow-y": "auto"
      },
      attrs: { id: "inspire" }
    },
    [
      _c("title-updater"),
      _vm._v(" "),
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { staticClass: "pa-0", attrs: { fluid: "", "fill-height": "" } },
            [
              _c(
                "v-layout",
                {
                  staticStyle: {
                    "max-height": "100vh",
                    "overflow-x": "hidden",
                    "overflow-y": "auto"
                  }
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "auth-background-section",
                      attrs: { xs12: "", sm12: "", md8: "" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "relative",
                            "background-image":
                              "url('/static/auth/background.png')",
                            "background-repeat": "no-repeat",
                            "background-size": "cover",
                            "background-position": "right",
                            height: "100%",
                            width: "100%",
                            left: "150px"
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              position: "absolute",
                              top: "0",
                              left: "-150px",
                              right: "0",
                              bottom: "0",
                              height: "100%"
                            },
                            attrs: { src: "/static/auth/front-new.svg" }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "d-flex justify-center align-center",
                      attrs: { xs12: "", sm12: "", md4: "" }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "fill-height d-flex flex-column w-full",
                          attrs: { flat: "" }
                        },
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass: "flex-grow-1 d-flex",
                              class: _vm.isMobile
                                ? "pa-0 flex-column justify-start align-center"
                                : "justify-center align-center"
                            },
                            [
                              _vm.isMobile
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "165px",
                                        position: "relative",
                                        "margin-bottom": "60px",
                                        "text-align": "center",
                                        display: "flex",
                                        "flex-direction": "column",
                                        "justify-content": "center",
                                        "align-items": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            top: "0",
                                            "z-index": "2",
                                            height: "170px"
                                          },
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 960 170.26"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              fill: "#244d52",
                                              d:
                                                "M0,0v141.8C490.3,220.07,784.9,125.05,960,0Z"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticStyle: {
                                          "z-index": "3",
                                          height: "60px",
                                          "margin-bottom": "10px"
                                        },
                                        attrs: {
                                          src: "/static/auth/lifecheq.svg"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._t("default")
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("v-card-actions", {
                            staticClass: "justify-center"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }